import React from "react";
import styled from "react-emotion";
import * as Components from "../../../components";
import { Search } from "../../../components/Report/components";
import { useTenantsBillingReports } from "./useTenantsBillingReports";
import { Link } from "react-router-dom";

const StyledSection = styled("section")`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px;
  & a {
    align-self: flex-start;
    font-size: 1.6rem;
    margin-bottom: 20px;
  }
  & h2 {
    font-size: 30px;
  }
  & .tenants__billing__activity {
    width: 100%;
  }
`;

export const TenantsBillingReports = () => {
  const { dateIsPicked, handleChange, handleSubmit, error, pickerDate } =
    useTenantsBillingReports(history);

  const description =
    "Download a CSV billing activity report for all tenants by selecting a month and year.";

  return (
    <StyledSection>
      <Link to="/all-tenants">{"<"} Back to All Tenants</Link>
      <Components.Widget
        title="All Tenant Billing Activity"
        className="tenants__billing__activity"
      >
        <Search
          handleDatePicked={handleChange}
          onSubmit={handleSubmit}
          searchTitle="All tenant billing activity"
          searchDescription={description}
          buttonText="Search and Download CSV"
          showMonthYearPicker={true}
          dateFormat="MMMM yyyy"
          disabled={!dateIsPicked || error}
          dateIsPicked={dateIsPicked}
          pickedDate={pickerDate}
          error={error}
          range={false}
        />
      </Components.Widget>
    </StyledSection>
  );
};
